var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-modal" }, [
    _c(
      "div",
      { staticClass: "notification-modal__inner" },
      [
        _c("ak-loader", { attrs: { loading: _vm.loading } }),
        _vm._v(" "),
        _c("h1", { staticClass: "ak-popover-menu__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "notification-modal__container" },
          _vm._l(_vm.messages, function (message, index) {
            return _c(
              "div",
              { key: index, staticClass: "notification-modal__loader" },
              [
                _c(
                  "p",
                  {
                    staticClass:
                      "ak-data-list__item notification-modal__message",
                  },
                  [_vm._v(_vm._s(index + 1 + " - " + message))]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "notification-modal__btn-container" }, [
          _c(
            "button",
            {
              staticClass: "notification-modal__btn ak-button ak-button--click",
              on: { click: _vm.loadMore },
            },
            [_vm._v("Load more")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "notification-modal__btn ak-button ak-button--click",
              on: { click: _vm.closeModal },
            },
            [_vm._v("Close")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }